export default "__VITE_ASSET__bb160313__"